// src/services/facebookPixel.ts
declare global {
    interface Window {
        fbq?: {
            (method: 'init', pixelId: string): void;
            (method: 'track', event: string, params?: Record<string, any>): void;
            queue?: any[];
            loaded?: boolean;
            callMethod?: Function;
            push?: Function;
        };
        _fbq?: any;
    }
}

const PIXEL_ID = '2387568735036068' || '';

// 确保 fbq 函数存在
function ensureFbq() {
    if (typeof window === 'undefined') return false;

    window.fbq = window.fbq || function() {
        if (window.fbq?.callMethod) {
            window.fbq.callMethod.apply(window.fbq, arguments);
        } else {
            (window._fbq = window._fbq || []).push(arguments);
        }
    };

    if (!window.fbq.queue) {
        window.fbq.queue = [];
        window.fbq.loaded = false;
        window.fbq.version = '2.0';
    }

    return true;
}

// 初始化 Pixel
export async function initFacebookPixel(): Promise<boolean> {
    if (!PIXEL_ID || !ensureFbq()) return false;

    // 已加载则直接返回
    if (window.fbq?.loaded) return true;

    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.id = 'facebook-pixel-script';
        script.async = true;
        script.defer = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';

        script.onload = () => {
            window.fbq!.loaded = true;
            window.fbq!('init', PIXEL_ID);
            window.fbq!('track', 'PageView');
            resolve(true);
        };
        script.onerror = () => {
            console.error('Facebook Pixel script failed to load');
            resolve(false);
        };

        document.head.appendChild(script);
    });
}

// 安全追踪事件
export async function trackFacebookEvent(
    eventName: string,
    params: Record<string, any> = {}
): Promise<boolean> {
    try {
        // 确保已初始化
        const initialized = await initFacebookPixel();
        if (!initialized) return false;

        // 安全调用
        if (window.fbq?.loaded) {
            window.fbq('track', eventName, params);
            return true;
        }

        // 如果未加载，加入队列
        window._fbq = window._fbq || [];
        window._fbq.push(['track', eventName, params]);
        return false;
    } catch (error) {
        console.error('Facebook Pixel tracking error:', error);
        return false;
    }
}